module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10041.47c36666.jpg";